import { useGetClaimByIdQuery } from "Order/Modules/Claim/Api/Query/getClaimByIdQuery";
import { AssignedPartnerWidget } from "Order/Modules/Claim/Widgets/AssignedPartnerWidget";
import { CustomerWidget } from "Order/Modules/Claim/Widgets/CustomerWidget";
import { ReplacedPartnerWidget } from "Order/Modules/Claim/Widgets/ReplacedPartnerWidget";
import { UpdateClaimCardWidget } from "Order/Modules/Claim/Widgets/UpdateClaimCardWidget";
import { Loading } from "Shared/Components/Loading/Loading";
import { Grid2, Stack, Typography } from "@mui/material";
import { toast } from "sonner";

export const OrderClaimTab = ({ order }) => {
	const claimId = order.claims?.[0]?.id;
	const { data: claim, isLoading, isSuccess } = useGetClaimByIdQuery(claimId);

	if (!order.claims || order.claims.length === 0) {
		return (
			<Grid2 container justifyContent="center" alignItems="center">
				<Typography variant="h2" mt={3}>
					There are no claims for this order
				</Typography>
			</Grid2>
		);
	}

	if (isLoading) {
		return (
			<Stack alignItems="center">
				<Loading />
			</Stack>
		);
	}

	if (!isSuccess || !claim) {
		return toast.error("Failed to load claim data");
	}

	return (
		<Stack spacing={2}>
			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12, md: 4 }}>
					<CustomerWidget customer={order.customer} />
				</Grid2>
				<Grid2 size={{ xs: 12, md: 4 }}>
					<AssignedPartnerWidget partner={order.partner} />
				</Grid2>
				<Grid2 size={{ xs: 12, md: 4 }}>
					<ReplacedPartnerWidget partner={claim.partner} />
				</Grid2>
			</Grid2>
			<UpdateClaimCardWidget
				claim={claim}
				isLoading={isLoading}
				orderId={order.id}
			/>
		</Stack>
	);
};
